import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { VehicleService } from "../../../services/nonanon/vehicle/vehicle.service";
import { VehicleInfoService } from "../../../services/nonanon/vehicle/vehicle-info.service";
import { Subscription } from "rxjs/Subscription";
import { NotificationComponent } from "../../shared/notification.component";
import { environment } from "../../../../environments/environment";
import { AuthHttp } from "angular2-jwt";
import { AuthService } from "../../../services/auth/auth.service";
import { ResponseContentType } from "@angular/http";
import { PVService } from "../../../services/nonanon/pv.service";
import { iResponseInfo } from "../../../interfaces/shared/iResponseInfo";
import { PersonInfoService } from '../../../services/nonanon/person/person-info.service';

@Component({
  selector: 'app-vehicle-info',
  templateUrl: './vehicle-info.component.html'
})
export class VehicleInfoComponent implements OnInit, OnDestroy {
  @ViewChild('notification') notificationComponent: NotificationComponent;

  onVehicleInfoChanged: Subscription;
  onVehicleSearchResultsChanged: Subscription;

  constructor(private vehicleService: VehicleService,
    private vehicleInfoService: VehicleInfoService,
    private authService: AuthService,
    private authHttp: AuthHttp,
    private pv: PVService) { }

  loading: boolean = false;


  //Security items for viewing vehicle information
  canViewVehicleMake: boolean = false;
  canViewVehicleModel: boolean = false;
  canViewVehicleYear: boolean = false;
  canViewVehiclePlateNumber: boolean = false;
  canViewVehicleColour: boolean = false;
  canViewVehicleTypeStyle: boolean = false;
  canViewVehicleJurisidiction: boolean = false;
  canViewRegistrationEffectiveDate: boolean = false;
  canViewRegistrationExpiryDate: boolean = false;
  canViewDecalId: boolean = false;
  canViewRegistrationStatus: boolean = false;


  private errorMessage: string = null;
  hasErrors() {
    return this.errorMessage != null;
  }
  getErrorMessage() {
    return this.hasErrors() ? this.errorMessage : "";
  }

  vehicleInfo: any;
  canCopyToClipboard: boolean = false;

  ngOnInit() {

    // Load security items for viewing vehicle information
    this.canCopyToClipboard = this.authService.getUser().canCopyToClipboard;

    this.canViewVehicleMake = this.authService.getUser().canViewVehicleMake;
    this.canViewVehicleModel = this.authService.getUser().canViewVehicleModel;
    this.canViewVehicleYear = this.authService.getUser().canViewVehicleYear;
    this.canViewVehiclePlateNumber = this.authService.getUser().canViewVehiclePlateNumber;
    this.canViewVehicleColour = this.authService.getUser().canViewVehicleColour;
    this.canViewVehicleTypeStyle = this.authService.getUser().canViewVehicleTypeStyle;
    this.canViewVehicleJurisidiction = this.authService.getUser().canViewVehicleJurisidiction;
    this.canViewRegistrationEffectiveDate = this.authService.getUser().canViewRegistrationEffectiveDate;
    this.canViewRegistrationExpiryDate = this.authService.getUser().canViewRegistrationExpiryDate;
    this.canViewDecalId = this.authService.getUser().canViewDecalId;
    this.canViewRegistrationStatus = this.authService.getUser().canViewRegistrationStatus;

    this.vehicleInfoService.clearVehicleInfo(this.vehicleService.getVehicle().id);
    
    //this.vehicleInfo = this.vehicleInfoService.getVehicleInfo();
    //this.vehicleInfo = this.vehicleInfoService.loadVehicleInfo(this.vehicleService.getVehicle().id);


    // since vehicleinfo is not set initially, every request will loadVEhicle info from API. 
    if (this.vehicleInfo == null) {
      this.loading = true;
      this.vehicleInfo = this.vehicleInfoService.loadVehicleInfo(this.vehicleService.getVehicle().id);
    }


    this.onVehicleInfoChanged = this.vehicleInfoService.vehicleInfoChanged
      .subscribe(
        () => {
          this.notificationComponent.animateIfError(this.vehicleInfoService.getResponseInfo());
          //this.vehicleInfoService.clearVehicleInfo(this.vehicleService.getVehicle().id);

          if (this.vehicleInfoService.hasErrors()) {
            this.errorMessage = this.vehicleInfoService.getErrorMessage();
            this.notificationComponent.animateErrorAction(this.errorMessage);
          } else {
            this.errorMessage = null;
            this.vehicleInfo = this.vehicleInfoService.getVehicleInfo();
            this.notificationComponent.clear();
          }

          this.loading = false;
        });

    this.onVehicleSearchResultsChanged = this.vehicleService.vehicleSearchResultsChanged
      .subscribe(
        () => {
          this.vehicleInfo = this.vehicleService.getVehicle();
          console.log()
          if (this.vehicleInfo != null) {
            this.vehicleInfoService.clearVehicleInfo(this.vehicleService.getVehicle().id);

            this.loading = true;
            this.vehicleInfoService.loadVehicleInfo(this.vehicleService.getVehicle().id);
          }
        });
  }

  copyToClipboard(text) {
    if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
      var textarea = document.createElement("textarea");
      textarea.textContent = text;
      textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea);
      textarea.select();
      try {
        return document.execCommand("copy"); // Security exception may be thrown by some browsers.
      } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    }
  }

  ngOnDestroy() {
    this.onVehicleInfoChanged.unsubscribe();
    this.onVehicleSearchResultsChanged.unsubscribe();
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/vehicle/vehicle-info.component.ts